























































































import Vue from 'vue';
import Component from 'vue-class-component';

/** The application footer */
@Component
export default class Conges extends Vue {
}
